import { render, staticRenderFns } from "./DecreasingPrices.vue?vue&type=template&id=2467296c"
import script from "./DecreasingPrices.vue?vue&type=script&lang=js"
export * from "./DecreasingPrices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports